<template>
    <div class="componentRoot" style="width: 100vw; overflow: hidden;">
        <v-container tag="header" fluid class="py-0">
            <v-row>
                <v-col style="position: relative">
                    <img alt="Symbolbild zum Coaching" fetchpriority="high" loading="eager" decoding="async" src="/images/pages/Coaching-1920-13017465.webp"
                        srcset="/images/pages/Coaching-640-d810c640.webp 640w, /images/pages/Coaching-960-0608cd37.webp 960w, /images/pages/Coaching-1600-e39f9910.webp 1600w, /images/pages/Coaching-1920-13017465.webp 1920w"
                        sizes="100vw" :style="{
                        height: imageHeight
                    }" style="
                        object-fit: cover; 
                        width: 100%;
                        object-position: top;" />

                    <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
                        :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
                        <p style="color: white; text-shadow: 0px 0px 7px #000000;"
                            v-html="$t('titleScreens.bannerText')"></p>
                        <h1 style="color: white; text-shadow: 0px 0px 7px #000000;" class="mb-4"
                            v-html="$t('titleScreens.lernen')"></h1>
                        <v-btn href="/kontakt#contactFormId" flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                                }}</v-btn><br>
                        <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
                            }}</small>
                    </div>
                </v-col>
            </v-row>


            <WaveVue aria-hidden="true" :color="'rgb(var(--v-theme-background))'" :negative="true"
                :style="{ 'margin-top': isMobile ? '-49px' : '-138px' }" :height="isMobile ? 30 : 120"
                style="z-index: 2; position: relative;" />

        </v-container>
        <v-container :fluid="$vuetify.display && $vuetify.display.width < 1920" style="max-width: 1920px">
            <v-row tag="nav" class="mt-16" style="margin-bottom: 134px">
                <v-col class="flex-col" style="align-items: center">
                    <a href="/staunendlernen" aria-current="page" class="flex-col"
                        style="text-decoration: none !important; color: rgb(var(--v-theme-on-background)); cursor: pointer; align-items: center;">
                        <img alt="Staunend lernen" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                            src="/images/icons/01_staunend_lernen_4c.svg" />
                        <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Staunend lernen</p>
                    </a>
                </v-col>
                <v-col class="flex-col inactivePoint" style="align-items: center;">
                    <a href="/eigenewege" class="flex-col"
                        style="text-decoration: none !important; color: rgb(var(--v-theme-on-background)); cursor: pointer; align-items: center;">
                        <img alt="Eigene Wege finden" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                            src="/images/icons/02_eigene_wege_finden_4c.svg" />
                        <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Eigene Wege finden</p>
                    </a>
                </v-col>
                <v-col class="flex-col inactivePoint" style="align-items: center">
                    <a href="/breathwork" class="flex-col"
                        style="text-decoration: none !important; color: rgb(var(--v-theme-on-background)); cursor: pointer; align-items: center;">
                        <img alt="Freiheit atmen" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                            src="/images/icons/03_freiheit_atmen_4c.svg" />
                        <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Freiheit Atmen</p>
                    </a>
                </v-col>
                <v-col class="flex-col inactivePointNoHover" style="align-items: center">
                        <img alt="Lebendig wachsen" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                            src="/images/icons/04_lebendig_wachsen_4c.svg" />
                        <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Lebendig wachsen</p>
                </v-col>
            </v-row>


            <v-row tag="section" aria-labelledby="lernen-sec1-title" v-if="!isMobile" class="wave-mask mx-0"
                style="margin-top: -70px; z-index: 2 !important; position: relative;" :style="{
                    'flex-direction': isMobile ? 'column-reverse' : 'row'
                }">
                <v-spacer v-if="!isXS" />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 id="lernen-sec1-title" class="seo-heading-display mb-4">{{ $t("lernen.sec1.title") }}</h2>
                    <div v-html="$t('lernen.sec1.text')"></div>
                </v-col>
                <v-spacer v-if="!isXS" />
                <v-col :cols="imageCols" class="pa-0">
                    <v-img alt="Symbolbild zur persönlichen Orientierung" style="height: 100%" cover src="/images/pages/AdobeStock_607094383-1600-60329f48.webp"
                        srcset="/images/pages/AdobeStock_607094383-640-271cc5aa.webp 640w, /images/pages/AdobeStock_607094383-960-ddf5a2de.webp 960w, /images/pages/AdobeStock_607094383-1600-60329f48.webp 1600w, /images/pages/AdobeStock_607094383-1920-9f6de2fe.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                </v-col>
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img alt="Symbolbild zur persönlichen Orientierung" style="height: 100%" cover src="/images/pages/AdobeStock_607094383-1600-60329f48.webp"
                        srcset="/images/pages/AdobeStock_607094383-640-271cc5aa.webp 640w, /images/pages/AdobeStock_607094383-960-ddf5a2de.webp 960w, /images/pages/AdobeStock_607094383-1600-60329f48.webp 1600w, /images/pages/AdobeStock_607094383-1920-9f6de2fe.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                    </v-col>
                </v-row>
                <v-row tag="section" aria-labelledby="lernen-sec1-title" class="wave-mask pb-16 px-8">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 id="lernen-sec1-title" class="seo-heading-display mb-4">{{ $t("lernen.sec1.title") }}</h2>
                        <div v-html="$t('lernen.sec1.text')"></div>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row tag="section" aria-labelledby="lernen-sec2-title" v-if="!isMobile" class="wave-mask mx-0">
                <v-col :cols="imageCols" class="pa-0">
                    <v-img alt="Natur als Sinnbild für Veränderung" style="height: 100%" cover src="/images/pages/Shift-Depression-to-Nature-1600-1b212ccf.webp"
                        srcset="/images/pages/Shift-Depression-to-Nature-640-d1799ea6.webp 640w, /images/pages/Shift-Depression-to-Nature-960-08ce8355.webp 960w, /images/pages/Shift-Depression-to-Nature-1600-1b212ccf.webp 1600w, /images/pages/Shift-Depression-to-Nature-1920-193a6221.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                </v-col>
                <v-spacer v-if="!isXS" />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 id="lernen-sec2-title" class="seo-heading-display mb-4">{{ $t("lernen.sec2.title") }}</h2>
                    <div v-html="$t('lernen.sec2.text')"></div>
                    <div class="px-6 pt-4 pb-6 mt-8"
                        style="background-image: linear-gradient(to left, rgba(98, 140, 3, 0) 0%, rgba(98, 140, 3, 0) 20%, rgb(98, 140, 3) 100%), url(/images/main/bg-str1.jpg); border-radius: 15px; width: fit-content; color: rgb(var(--v-theme-light))">
                        <a href="/eigenewege" style="text-decoration: none; color: rgb(var(--v-theme-light))">
                            <div v-html="$t('lernen.sec2.gohere')"></div>
                            <div class="flex-row pt-4" style="align-items: center">
                                <img alt="Eigene Wege finden" loading="lazy" decoding="async" style="height: 70px" cover src="/images/icons/02_eigene_wege_finden_1c_n.svg" />
                                <h3 class="seo-heading-display pl-6">{{ $t("lernen.sec2.theme") }}</h3>
                            </div>
                        </a>
                    </div>
                </v-col>
                <v-spacer v-if="!isXS" />
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img alt="Natur als Sinnbild für Veränderung" style="height: 100%" cover src="/images/pages/Shift-Depression-to-Nature-1600-1b212ccf.webp"
                        srcset="/images/pages/Shift-Depression-to-Nature-640-d1799ea6.webp 640w, /images/pages/Shift-Depression-to-Nature-960-08ce8355.webp 960w, /images/pages/Shift-Depression-to-Nature-1600-1b212ccf.webp 1600w, /images/pages/Shift-Depression-to-Nature-1920-193a6221.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                    </v-col>
                </v-row>
                <v-row tag="section" aria-labelledby="lernen-sec2-title" class="wave-mask pb-16 px-8">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 id="lernen-sec2-title" class="seo-heading-display mb-4">{{ $t("lernen.sec2.title") }}</h2>
                        <div v-html="$t('lernen.sec2.text')"></div>
                        <div class="px-6 pt-4 pb-6 mt-8"
                            style="background-image: linear-gradient(to left, rgba(98, 140, 3, 0) 0%, rgba(98, 140, 3, 0) 20%, rgb(98, 140, 3) 100%), url(/images/main/bg-str1.jpg); border-radius: 15px; width: fit-content; color: rgb(var(--v-theme-light))">
                            <a href="/eigenewege" style="text-decoration: none; color: rgb(var(--v-theme-light))">
                                <div v-html="$t('lernen.sec2.gohere')"></div>
                                <div class="flex-row pt-4" style="align-items: center">
                                    <img alt="Eigene Wege finden" loading="lazy" decoding="async" style="height: 70px" cover src="/images/icons/02_eigene_wege_finden_1c_n.svg" />
                                    <h3 v-if="!isMobile" class="seo-heading-display pl-6">{{ $t("lernen.sec2.theme") }}</h3>
                                    <h3 v-if="isMobile" class="pl-6">{{ $t("lernen.sec2.theme") }}</h3>
                                </div>
                            </a>
                        </div>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row tag="section" aria-labelledby="lernen-sec3-title" v-if="!isMobile" class="wave-mask mx-0"
                style="margin-top: -70px; z-index: 2 !important; position: relative;" :style="{
                    'flex-direction': isMobile ? 'column-reverse' : 'row'
                }">
                <v-spacer v-if="!isXS" />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 id="lernen-sec3-title" class="seo-heading-display mb-4">{{ $t("lernen.sec3.title") }}</h2>
                    <div v-html="$t('lernen.sec3.text')"></div>
                </v-col>
                <v-spacer v-if="!isXS" />
                <v-col :cols="imageCols" class="pa-0">
                    <v-img alt="Begleitbild zum Coaching" style="height: 100%" cover src="/images/pages/_MG_7281-1600-c63c8986.webp"
                        srcset="/images/pages/_MG_7281-640-b3e41cdf.webp 640w, /images/pages/_MG_7281-960-0c674d1e.webp 960w, /images/pages/_MG_7281-1600-c63c8986.webp 1600w, /images/pages/_MG_7281-1920-fe543e8f.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                </v-col>
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img alt="Begleitbild zum Coaching" style="height: 100%" cover src="/images/pages/_MG_7281-1600-c63c8986.webp"
                        srcset="/images/pages/_MG_7281-640-b3e41cdf.webp 640w, /images/pages/_MG_7281-960-0c674d1e.webp 960w, /images/pages/_MG_7281-1600-c63c8986.webp 1600w, /images/pages/_MG_7281-1920-fe543e8f.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                    </v-col>
                </v-row>
                <v-row tag="section" aria-labelledby="lernen-sec3-title" class="wave-mask pb-16 px-8">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 id="lernen-sec3-title" class="seo-heading-display mb-4">{{ $t("lernen.sec3.title") }}</h2>
                        <div v-html="$t('lernen.sec3.text')"></div>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row tag="section" aria-labelledby="lernen-sec4-title" class="mx-0 background-background wave-mask"
                style="margin-top: -70px; z-index: 2 !important; position: relative;" :style="{
                    'flex-direction': isMobile ? 'column-reverse' : 'row'
                }">
                <v-col :cols="imageCols" class="pa-8" :class="{ 'pb-16': isMobile }"
                    style="display: flex;align-items: center; justify-content: center;">
                    <img alt="Begleitbild zur Kontaktaufnahme" loading="lazy" decoding="async" :style="{ height: smallImageHeight }" class="rounded-lg" src="/images/pages/Kontakt-1600-a53195ff.webp"
                        srcset="/images/pages/Kontakt-640-48e37c21.webp 640w, /images/pages/Kontakt-960-c4eb9062.webp 960w, /images/pages/Kontakt-1600-a53195ff.webp 1600w, /images/pages/Kontakt-1920-daf4f1f0.webp 1920w"
                        sizes="(max-width: 600px) 250px, (max-width: 960px) 350px, 550px"
                        style="aspect-ratio: 1; object-fit: cover;" />
                </v-col>
                <v-spacer />
                <v-col :cols="textCols" class="mb-8 px-8"
                    style=" display: flex; justify-content: center; flex-direction: column;"
                    :style="{ padding: isMobile ? '110px 16px 60px' : '200px 16px' }">
                    <h2 id="lernen-sec4-title" class="seo-heading-display mb-4">{{ $t("lernen.sec4.title") }}</h2>
                    <div v-html="$t('lernen.sec4.text')"></div>
                </v-col>
                <v-spacer />
            </v-row>


            <v-row tag="section" aria-labelledby="staunendlernen-information-1" class="mx-0 seo-information-section"
                style="position: relative; border-radius: 15px;"
                :style="{ padding: isMobile ? '56px 8px' : '88px 16px' }">
                <v-spacer />
                <v-col cols="12" md="10" lg="8" xl="7" class="px-6 px-md-8">
                    <h2 id="staunendlernen-information-1" class="seo-information-heading mb-6">{{ $t("seoContent.staunendlernen.section1.title") }}</h2>
                    <p>{{ $t("seoContent.staunendlernen.section1.paragraph1") }}</p>
                    <p>{{ $t("seoContent.staunendlernen.section1.paragraph2") }}</p>
                </v-col>
                <v-spacer />
            </v-row>

            <v-row tag="section" aria-labelledby="staunendlernen-information-2" class="mx-0 seo-information-section"
                style="position: relative; border-radius: 15px;"
                :style="{ padding: isMobile ? '56px 8px' : '88px 16px', backgroundColor: 'rgb(var(--v-theme-light))' }">
                <v-spacer />
                <v-col cols="12" md="10" lg="8" xl="7" class="px-6 px-md-8">
                    <h2 id="staunendlernen-information-2" class="seo-information-heading mb-6">{{ $t("seoContent.staunendlernen.section2.title") }}</h2>
                    <p>{{ $t("seoContent.staunendlernen.section2.paragraph1") }}</p>
                    <p>{{ $t("seoContent.staunendlernen.section2.paragraph2") }}</p>
                    <v-btn href="/kontakt#contactFormId" flat class="primaryButton mt-8 rounded-xl">{{ $t("landing.contactText2") }}</v-btn>
                </v-col>
                <v-spacer />
            </v-row>

        </v-container>
    </div>
</template>

<script>

export default {
    name: "freiheitAtmen",

    computed: {
        smallImageHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "250px"
                case "sm":
                    return "350px"
                case "md":
                    return "350px"
                case "lg":
                    return "550px"
                case "xl":
                    return "550px"
                case "xxl":
                    return "550px"
                default:
                    return "550px"
            }
        },
        leftAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        rightAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        leftServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "8";
                case "lg":
                    return "8";
                case "xl":
                    return "8";
                case "xxl":
                    return "8";
                default:
                    return "8";
            }
        },
        rightServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "4";
                case "lg":
                    return "4";
                case "xl":
                    return "4";
                case "xxl":
                    return "4";
                default:
                    return "4";
            }
        },
        marginLeftOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "0px";
                case "sm":
                    return "0px";
                case "md":
                    return "50px";
                case "lg":
                    return "100px";
                case "xl":
                    return "50px";
                case "xxl":
                    return "50px";
                default:
                    return "50px";
            }
        },
        imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90%";
                case "sm":
                    return "90%";
                case "md":
                    return "90%";
                case "lg":
                    return "80%";
                case "xl":
                    return "80%";
                case "xxl":
                    return "60%"
                default:
                    return "60%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "10%";
                case "sm":
                    return "10%";
                case "md":
                    return "10%";
                case "lg":
                    return "10%";
                case "xl":
                    return "10%";
                case "xxl":
                    return "15%"
                default:
                    return "15%"
            }
        },
        spacerHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "100px";
                case "sm":
                    return "100px";
                case "md":
                    return "100px";
                case "lg":
                    return "100px";
                case "xl":
                    return "100px";
                case "xxl":
                    return "100px";
                default:
                    return "100px";
            }
        },
        mainCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 7;
                case "lg":
                    return 7;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        imageCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 6;
                case "lg":
                    return 6;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        textCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 11;
                case "sm":
                    return 11;
                case "md":
                    return 5;
                case "lg":
                    return 5;
                case "xl":
                    return 4;
                case "xxl":
                    return 4;
                default:
                    return 3;
            }
        },
        navCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 2;
                case "sm":
                    return "auto";
                case "md":
                    return "auto";
                case "lg":
                    return "auto";
                case "xl":
                    return "auto";
                case "xxl":
                    return "auto";
                default:
                    return "auto";
            }
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        isTooTight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return '1fr';
                case "sm":
                    return '1fr 1fr';
                case "md":
                    return '1fr 1fr';
                case "lg":
                    return '1fr 1fr 1fr 1fr';
                case "xl":
                    return '1fr 1fr 1fr 1fr';
                case "xxl":
                    return '1fr 1fr 1fr 1fr';
                default:
                    return '1fr 1fr 1fr 1fr';
            }
        },
        isXS() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return false;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        QuadWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 3;
                case "sm":
                    return 3;
                case "md":
                    return 6;
                case "lg":
                    return 6;
                case "xl":
                    return 8;
                case "xxl":
                    return 8;
                default:
                    return false;
            }
        },
    },
}
</script>

<style scoped>

/* Additional information follows the existing typography and theme colors. */
.seo-information-heading {
    font-size: 2em;
    font-weight: 500;
    line-height: 1.3;
}
.seo-information-section p {
    line-height: 1.8;
}
.seo-information-section p + p {
    margin-top: 1rem;
}
.seo-information-section a:not(.v-btn) {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.2em;
}
.seo-qualification-draft {
    margin-top: 2rem;
    padding: 1.5rem;
    border: 1px dashed currentColor;
    border-radius: 15px;
}
.seo-qualification-draft li + li {
    margin-top: 0.75rem;
}

/* Preserve the original h1 scale after correcting the document outline. */
.seo-heading-display {
    font-size: 2em;
    font-weight: 500;
}

/* Keep existing navigation text available on small screens. */
.seo-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
</style>
